import React from "react";

export const RolesColumns = (confirmDelete, onEditPermission, onViewMembers) => [
    {
        Header: "ID",
        accessor: "id",
        className: "id-width-roles",
        isShortIcon: true,
    },
    {
        Header: "Role Name",
        accessor: "role_name",
        isInfoIcon: true,
        isShortIcon: true,
        className: "role-name-width",
    },
    {
        Header: "Count",
        accessor: "count",
        isInfoIcon: true,
        isShortIcon: true,
        className: "role-status-width text-center",
    },
    {
        Header: "Action",
        accessor: "action",
        isInfoIcon: true,
        isShortIcon: false,
        className: "action-roles",
        Cell: cellProps => {
            return (
                <div>
                    <a
                        onClick={() => onViewMembers(cellProps.row.original.staff_names)}
                        className="btn action-btn btn-sm me-1 btn-outline-secondary"
                    >
                        <i className="fas fa-eye"></i>
                    </a>
                    <a
                        onClick={() => onEditPermission(cellProps.row.original.id)}
                        className="btn action-btn btn-sm me-1 btn-outline-secondary"
                    >
                        <i className="fas fa-pencil-alt"></i>
                    </a>
                    <a
                        onClick={() => confirmDelete(cellProps.row.original.id, cellProps?.row.original.count)}
                        className="btn btn-sm action-btn btn-outline-danger"
                    >
                        <i className="fas fa-trash-alt"></i>
                    </a>
                </div>
            )
        },
    },
]


const STEPS = [
    { key: "step1", label: "Services" },
    { key: "step2", label: "Features" },
    { key: "step3", label: "Timing" },
    { key: "step4", label: "Costing" },
    { key: "step5", label: "Overview" },
];

const permSummary = (parsed) => {
    if (!parsed) return <span className="badge bg-danger">No Access</span>;
    const count = STEPS.filter((s) => parsed[s.key]?.view === 1).length;
    if (count === 0) return <span className="badge bg-danger">No Access</span>;
    if (count === 5) return <span className="badge bg-success">Full Access</span>;
    return <span className="badge" style={{ background: "#EDE0F5", color: "#752A97" }}>{count} Steps</span>;
};

export const RfpPermissionsColumns = (onEdit, onDelete, getUserName) => [
    {
        Header: "ID",
        accessor: "user_id",
        className: "id-width-roles text-center",
        isShortIcon: true,
        width: 70,
        Cell: ({ row }) => <span>{row.index + 1}</span>,
    },

    {
        Header: "User",
        accessor: "user_name",
        isShortIcon: true,
        className: "role-name-width",
        width: 280,
        Cell: ({ row }) => {
            const name = getUserName(row.original.user_id);

            return (
                <div className="d-flex align-items-center gap-2">
                    <div
                        style={{
                            width: "28px",
                            height: "28px",
                            borderRadius: "50%",
                            background: "#752A97",
                            color: "#fff",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            fontSize: "11px",
                            fontWeight: 700,
                            flexShrink: 0,
                        }}
                    >
                        {name?.[0]?.toUpperCase()}
                    </div>

                    <span className="fw-semibold text-nowrap">
                        {name}
                    </span>
                </div>
            );
        },
    },

    ...STEPS.map((s) => ({
        Header: s.label,
        accessor: s.key,
        className: "text-center permission-column",
        isShortIcon: false,
        width: 100,

        Cell: ({ row }) =>
            row.original.parsed?.[s.key]?.view === 1 ? (
                <i className="fas fa-check-circle text-success fs-5"></i>
            ) : (
                <i
                    className="fas fa-times-circle fs-5"
                    style={{ color: "#ddd" }}
                ></i>
            ),
    })),

    {
        Header: "Access",
        accessor: "access",
        className: "text-center",
        isShortIcon: false,
        width: 140,

        Cell: ({ row }) => permSummary(row.original.parsed),
    },

    {
        Header: "Action",
        accessor: "action",
        isInfoIcon: false,
        isShortIcon: false,
        className: "action-roles text-center",
        width: 140,

        Cell: ({ row }) => (
            <div className="d-flex justify-content-center gap-1">
                <a
                    className="btn action-btn btn-sm me-1 btn-outline-secondary"
                    onClick={() => onEdit(row.original.user_id)}
                    title="Edit"
                >
                    <i className="fas fa-pencil-alt"></i>
                </a>

                <a
                    className="btn btn-sm action-btn btn-outline-danger"
                    onClick={() => onDelete(row.original.user_id)}
                    title="Delete"
                >
                    <i className="fas fa-trash-alt"></i>
                </a>
            </div>
        ),
    },
];